import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, Button } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';

import { Link as Links } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
    <Box sx={{ bgcolor: '#212121', color: '#fff', py: 4, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Us Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h1" gutterBottom sx={{fontSize:'larger' }}>
              About Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              We provide reliable and affordable taxi services to get you where you need to go. Our experienced drivers and well-maintained vehicles ensure a safe and comfortable ride.
            </Typography>
            <Links 
  to="/contact" 
  style={{ 
    textDecoration: 'none', 
    display: 'inline-block' 
  }}
>
  <Button 
    variant="contained" 
    color="secondary" 
    sx={{
      fontSize: '1rem', 
      padding: '10px 20px', 
      borderRadius: 2, 
      boxShadow: 3, 
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: 6,
      }
    }}
  >
    Contact Us
  </Button>
</Links>
          </Grid>

          {/* Services Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h1" gutterBottom sx={{fontSize:'larger' }}>
              Services
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link  color="inherit" variant="body2">
                  Airport Transfers
                </Link>
              </li>
              <li>
                <Link color="inherit" variant="body2">
                  Corporate Rides
                </Link>
              </li>
              <li>
                <Link  color="inherit" variant="body2">
                  City Tours
                </Link>
              </li>
              <li>
                <Link color="inherit" variant="body2">
                  Custom Requests
                </Link>
              </li>
            </ul>
          </Grid>

          {/* Contact Us Section */}
          <Grid item xs={12} md={4} sx={{padding:0}}>
            <Typography variant="h1" gutterBottom sx={{fontSize:'larger' }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              289.2/365.A SRM Thottam , shanmuganagar , dhadhagapatty
              Salem - 636006
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Phone: 9965821750
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Email: vrsslm92@gmail.com
            </Typography>
            <Button variant="outlined" color="secondary" >
              Support
            </Button>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: '#424242' }} />

        <Grid container spacing={2} justifyContent="center">
          {/* Social Media Icons */}
          <Grid item>
            <Link href="https://facebook.com" color="inherit" target="_blank" rel="noopener noreferrer">
              <Facebook />
            </Link>
          </Grid>
          <Grid item>
            <Link href="https://twitter.com" color="inherit" target="_blank" rel="noopener noreferrer">
              <Twitter />
            </Link>
          </Grid>
          <Grid item>
            <Link href="https://instagram.com" color="inherit" target="_blank" rel="noopener noreferrer">
              <Instagram />
            </Link>
          </Grid>
          <Grid item>
            <Link href="https://linkedin.com" color="inherit" target="_blank" rel="noopener noreferrer">
              <LinkedIn />
            </Link>
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            &copy; {new Date().getFullYear()} Taxi Service. All rights reserved.
          </Typography>
          <Link  color="inherit" variant="body2">
            Privacy Policy
          </Link>
          {' | '}
          <Link  color="inherit" variant="body2">
            Terms of Service
          </Link>
        </Box>
      </Container>
    </Box>
    </footer>
  );
};

export default Footer;
